
import React, { useState, useEffect, useCallback } from "react";
import "./StudentReportDashboard.css";

import {
  FaGraduationCap,
  FaSchool,
  FaSearch,
  FaBookOpen,
  FaChevronLeft,
  FaChevronRight,
  FaTimes,
  FaHome,
  FaBars,
} from "react-icons/fa";

/* ============================================================
   SLIDER IMAGE IMPORTS
   ============================================================ */

import slider1 from "../assets/School1.jpg";
import slider2 from "../assets/School2.jpg";
import slider3 from "../assets/School3.avif";
import slider4 from "../assets/School4.jpg";

/* ============================================================
   SLIDER DATA
   ============================================================ */

const sliders = [
  {
    id: 1,
    image: slider1,
    alt: "Student Report Slide 1",
  },
  {
    id: 2,
    image: slider2,
    alt: "Student Report Slide 2",
  },
  {
    id: 3,
    image: slider3,
    alt: "Student Report Slide 3",
  },
  {
    id: 4,
    image: slider4,
    alt: "Student Report Slide 3",
  },
];

/* ============================================================
   CARD DATA
   ============================================================ */

const cards = [
  {
    id: "3",
    title: "Class Group/Category Wise Enrollment",
    icon: FaGraduationCap,
  },
  {
    id: "4",
    title: "Class Group/Gender Wise Enrollment",
    icon: FaSchool,
  },
  {
    id: "5",
    title: "Class Wise Enrollment",
    icon: FaSearch,
  },
  {
    id: "7",
    title: "CWSN Students Enrollment",
    icon: FaBookOpen,
  },
];

/* ============================================================
   ENROLLMENT DATA
   ============================================================ */

const enrollmentData = [
  {
    group: "1-5",
    boxId: "clsbox1TO5",
    data: [
      { cat: "General", val: 222884, key: "General" },
      { cat: "ST", val: 889291, key: "ST" },
      { cat: "SC", val: 847774, key: "SC" },
      { cat: "OBC", val: 1051092, key: "OBC" },
      { cat: "SBC", val: 205164, key: "SBC" },
    ],
  },
  {
    group: "11-12",
    boxId: "clsbox11TO12",
    data: [
      { cat: "General", val: 112456, key: "General" },
      { cat: "ST", val: 197875, key: "ST" },
      { cat: "SC", val: 270237, key: "SC" },
      { cat: "OBC", val: 421941, key: "OBC" },
      { cat: "SBC", val: 65292, key: "SBC" },
    ],
  },
  {
    group: "6-8",
    boxId: "clsbox6TO8",
    data: [
      { cat: "General", val: 166743, key: "General" },
      { cat: "ST", val: 482610, key: "ST" },
      { cat: "SC", val: 545509, key: "SC" },
      { cat: "OBC", val: 740477, key: "OBC" },
      { cat: "SBC", val: 139741, key: "SBC" },
    ],
  },
  {
    group: "9-10",
    boxId: "clsbox9TO10",
    data: [
      { cat: "General", val: 124528, key: "General" },
      { cat: "ST", val: 283273, key: "ST" },
      { cat: "SC", val: 360079, key: "SC" },
      { cat: "OBC", val: 506575, key: "OBC" },
      { cat: "SBC", val: 90566, key: "SBC" },
    ],
  },
];

/* ============================================================
   COMPONENT
   ============================================================ */

const StudentReportDashboard = () => {
  const [activeCard, setActiveCard] = useState("3");

  const [popupOpen, setPopupOpen] = useState(false);

  const [schoolInfoOpen, setSchoolInfoOpen] = useState(false);

  const [dialogVisible, setDialogVisible] = useState(null);

  const [currentSlide, setCurrentSlide] = useState(0);

  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  /* ============================================================
     AUTO SLIDER
     ============================================================ */

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(
        (prev) => (prev + 1) % sliders.length
      );
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  /* ============================================================
     SLIDER FUNCTIONS
     ============================================================ */

  const goToSlide = useCallback((index) => {
    setCurrentSlide(index);
  }, []);

  const nextSlide = useCallback(() => {
    setCurrentSlide(
      (prev) => (prev + 1) % sliders.length
    );
  }, []);

  const prevSlide = useCallback(() => {
    setCurrentSlide(
      (prev) =>
        (prev - 1 + sliders.length) % sliders.length
    );
  }, []);

  /* ============================================================
     POPUP FUNCTIONS
     ============================================================ */

  const showPopup = (id) => {
    setActiveCard(id);
    setPopupOpen(true);
  };

  const closePopup = () => {
    setPopupOpen(false);
  };

  const showSchoolInfo = () => {
    setSchoolInfoOpen(true);
  };

  const closeSchoolInfo = () => {
    setSchoolInfoOpen(false);
  };

  /* ============================================================
     DIALOG
     ============================================================ */

  const showDiv = (id) => {
    setDialogVisible(id);
  };

  const hideDiv = () => {
    setDialogVisible(null);
  };

  /* ============================================================
     TABLE CLICK
     ============================================================ */

  const handleGetId = (group, num, cat) => {
    console.log(
      "getidforclassgroup:",
      group,
      num,
      cat
    );
  };

  /* ============================================================
     RETURN
     ============================================================ */

  return (
    <div className="student-report-page">

  

      {/* ========================================================
          HERO SLIDER
      ======================================================== */}

      <div id="divbanner">
        <section className="hero_banner">

          <div className="student-slider">

            <div
              className="slider_track"
              style={{
                transform: `translateX(-${
                  currentSlide * 100
                }%)`,
              }}
            >
              {sliders.map((slide) => (
                <div
                  key={slide.id}
                  className="slider_slide"
                >
                  <img
                    src={slide.image}
                    alt={slide.alt}
                    className="slider_img"
                  />

                  <div className="slider_overlay" />
                </div>
              ))}
            </div>

            {/* Previous */}
            <button
              type="button"
              className="slider_arrow prev"
              onClick={prevSlide}
              aria-label="Previous slide"
            >
              <FaChevronLeft />
            </button>

            {/* Next */}
            <button
              type="button"
              className="slider_arrow next"
              onClick={nextSlide}
              aria-label="Next slide"
            >
              <FaChevronRight />
            </button>

            {/* Dots */}
            <div className="slider_dots">
              {sliders.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  className={
                    currentSlide === index
                      ? "active"
                      : ""
                  }
                  onClick={() =>
                    goToSlide(index)
                  }
                  aria-label={`Go to slide ${
                    index + 1
                  }`}
                />
              ))}
            </div>

          </div>
        </section>
      </div>

      {/* ========================================================
          MAIN CONTENT
      ======================================================== */}

      <section className="main-section">

        <div className="container">

          <div className="row">

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">

              <section>

                <div className="about">

                  {/* Breadcrumb */}

                  <div className="row">

                    <div className="col-xs-12">

                      <ol className="breadcrumb breadcrumb-arrow">
{/* 
                        <li>
                          <a href="">
                            Citizen Window
                          </a>
                        </li>

                        <li className="active">
                          <a>
                            Class Group/Category Wise
                            Enrollment
                          </a>
                        </li> */}

                      </ol>

                    </div>

                  </div>

                  {/* Heading */}

                  <div className="row">

                    <div className="col-xs-12 text-center">

                      <h1>
                        Student Reports
                      </h1>

                      <p className="page-subtitle">
                        Explore student enrollment
                        reports and statistics
                      </p>

                    </div>

                  </div>

                  {/* ==================================================
                      CARDS
                  ================================================== */}

                  <div
                    className="card-container"
                    id="divsearchdashboard"
                  >

                    {cards.map((card) => {

                      const Icon = card.icon;

                      return (
                        <div
                          key={card.id}
                          className={`report-card ${
                            activeCard === card.id
                              ? "active"
                              : ""
                          }`}
                          onClick={() =>
                            showPopup(card.id)
                          }
                        >

                          {/* Front */}

                          <div className="card-face card-front">

                            <div className="icon-wrapper">

                              <Icon />

                            </div>

                            <div className="card-content">

                              <h3>
                                {card.title}
                              </h3>

                              <span className="view-text">
                                View Report
                              </span>

                            </div>

                          </div>

                          {/* Back */}

                          <div className="card-face card-back">

                            <div className="icon-wrapper">

                              <Icon />

                            </div>

                            <h3>
                              {card.title}
                            </h3>

                            <button
                              type="button"
                              className="card-button"
                              onClick={(e) => {
                                e.stopPropagation();
                                showPopup(card.id);
                              }}
                            >
                              View Details
                            </button>

                          </div>

                        </div>
                      );

                    })}

                  </div>

                </div>

              </section>

              {/* ====================================================
                  ENROLLMENT MODAL
              ==================================================== */}

              {popupOpen && (

                <div
                  className="custom-modal"
                  role="dialog"
                  aria-modal="true"
                >

                  <div
                    className="modal-overlay"
                    onClick={closePopup}
                  />

                  <div className="modal-dialog">

                    <div className="modal-content">

                      <div className="modal-header">

                        <div>

                          <span className="modal-label">
                            Student Report
                          </span>

                          <h2>
                            Class Group/Category
                            Wise Enrollment
                          </h2>

                        </div>

                        <button
                          type="button"
                          className="modal-close"
                          onClick={closePopup}
                          aria-label="Close"
                        >
                          <FaTimes />
                        </button>

                      </div>

                      <div className="modal-body">

                        <div className="section-title">

                          <div className="section-icon">
                            <FaGraduationCap />
                          </div>

                          <h3>
                            Enrollment
                          </h3>

                        </div>

                        <div className="table-responsive">

                          <table className="classGroup">

                            <thead>

                              <tr>

                                <th rowSpan={2}>
                                  Class Group
                                </th>

                                <th colSpan={5}>
                                  Enrollment
                                </th>

                              </tr>

                              <tr>

                                <th>GEN</th>
                                <th>ST</th>
                                <th>SC</th>
                                <th>OBC</th>
                                <th>SBC</th>

                              </tr>

                            </thead>

                            <tbody>

                              {enrollmentData.map(
                                (row) => (

                                  <tr
                                    key={row.boxId}
                                  >

                                    <td className="group-cell">

                                      <div className="group-link-wrapper">

                                        {dialogVisible ===
                                          row.boxId && (

                                          <div className="dialogueBox">

                                            <div className="dialog-heading">

                                              About

                                              <button
                                                type="button"
                                                onClick={
                                                  hideDiv
                                                }
                                              >
                                                <FaTimes />
                                              </button>

                                            </div>

                                            <p>
                                              Class group{" "}
                                              {row.group}{" "}
                                              enrollment
                                              details.
                                            </p>

                                          </div>

                                        )}

                                        <button
                                          type="button"
                                          className="group-link"
                                          onMouseEnter={() =>
                                            showDiv(
                                              row.boxId
                                            )
                                          }
                                          onMouseLeave={
                                            hideDiv
                                          }
                                        >
                                          {row.group}
                                        </button>

                                      </div>

                                    </td>

                                    {row.data.map(
                                      (d) => (

                                        <td
                                          key={d.key}
                                        >

                                          <a
                                            href=""
                                            onClick={() =>
                                              handleGetId(
                                                row.group,
                                                "1",
                                                d.key
                                              )
                                            }
                                            target="_blank"
                                            rel="noreferrer"
                                          >
                                            {d.val.toLocaleString()}
                                          </a>

                                        </td>

                                      )
                                    )}

                                  </tr>

                                )
                              )}

                            </tbody>

                          </table>

                        </div>

                      </div>

                      <div className="modal-footer">

                        <button
                          type="button"
                          className="modal-button"
                          onClick={closePopup}
                        >
                          Close
                        </button>

                      </div>

                    </div>

                  </div>

                </div>

              )}

              {/* ====================================================
                  SCHOOL INFORMATION MODAL
              ==================================================== */}

              {schoolInfoOpen && (

                <div className="custom-modal">

                  <div
                    className="modal-overlay"
                    onClick={closeSchoolInfo}
                  />

                  <div className="modal-dialog">

                    <div className="modal-content">

                      <div className="modal-header">

                        <div>

                          <span className="modal-label">
                            School Details
                          </span>

                          <h2>
                            School Information
                          </h2>

                        </div>

                        <button
                          type="button"
                          className="modal-close"
                          onClick={
                            closeSchoolInfo
                          }
                        >
                          <FaTimes />
                        </button>

                      </div>

                      <div className="modal-body">

                        <div className="info-block">

                          <h3>
                            School Basic Information
                          </h3>

                          <div className="info-grid">

                            <InfoItem
                              label="School Name"
                            />

                            <InfoItem
                              label="Shaladarpan Code"
                            />

                            <InfoItem
                              label="UDise Code"
                            />

                            <InfoItem
                              label="District"
                            />

                            <InfoItem
                              label="Block"
                            />

                          </div>

                        </div>

                        <div className="info-block">

                          <h3>
                            School Contact Detail
                          </h3>

                          <div className="info-grid">

                            <InfoItem
                              label="Headmaster or Principal"
                            />

                            <InfoItem
                              label="School Email"
                            />

                            <InfoItem
                              label="Locality"
                            />

                            <InfoItem
                              label="Pincode"
                            />

                          </div>

                        </div>

                        <div className="info-block">

                          <h3>
                            Detailed School
                            Information
                          </h3>

                          <div className="info-grid">

                            <InfoItem
                              label="Rural/Urban"
                            />

                            <InfoItem
                              label="School Management"
                            />

                            <InfoItem
                              label="TSP Area / Non TSP Area"
                            />

                            <InfoItem
                              label="Low Class"
                            />

                            <InfoItem
                              label="High Class"
                            />

                            <InfoItem
                              label="PEEO"
                            />

                            <InfoItem
                              label="Sanskrit"
                            />

                            <InfoItem
                              label="Residential / Hostel School"
                            />

                            <InfoItem
                              label="CWSN School"
                            />

                            <InfoItem
                              label="Computer Lab"
                            />

                            <InfoItem
                              label="Play Ground"
                            />

                          </div>

                        </div>

                      </div>

                      <div className="modal-footer">

                        <button
                          type="button"
                          className="modal-button"
                          onClick={
                            closeSchoolInfo
                          }
                        >
                          Close
                        </button>

                      </div>

                    </div>

                  </div>

                </div>

              )}

            </div>

          </div>

        </div>

      </section>

      {/* ========================================================
          MOBILE NAVIGATION
      ======================================================== */}

      <nav
        className={`mobile-nav ${
          mobileNavOpen ? "open" : ""
        }`}
      >

        <div className="mobile-nav-header">

          <span>
            Citizen Window
          </span>

          <button
            type="button"
            onClick={() =>
              setMobileNavOpen(false)
            }
          >
            <FaTimes />
          </button>

        </div>

        <ul>

          <li>
            <a href="">
              <FaHome />
              Home
            </a>
          </li>

          <li>
            <a href="">
              Search Schools
            </a>
          </li>

          <li>
            <a href="">
              Search Schemes
            </a>
          </li>

          <li>
            <a href="">
              Prayas
            </a>
          </li>

          <li>
            <a href="">
              NAS Question Bank
            </a>
          </li>

          <li>
            <a href="">
              Board Exam Question Bank
            </a>
          </li>

          <li>
            <a href="">
              Suggestions from Citizen
            </a>
          </li>

          <li>
            <a href="">
              Student Reports
            </a>
          </li>

        </ul>

      </nav>

      {mobileNavOpen && (
        <div
          className="mobile-nav-overlay"
          onClick={() =>
            setMobileNavOpen(false)
          }
        />
      )}

      {/* ========================================================
          LOADER
      ======================================================== */}

      <div
        id="divLoaderImage"
        className="LoaderImage"
        style={{ display: "none" }}
      />

    </div>
  );
};

/* ============================================================
   INFO ITEM
   ============================================================ */

const InfoItem = ({ label }) => {
  return (
    <div className="info-item">

      <div className="info-label">
        {label}
      </div>

      <div className="info-value">
        -
      </div>

    </div>
  );
};

export default  StudentReportDashboard;

